export const inventory = {
  description: "مستويات المخزون وحركاته وصرف المواد لأوامر العمل.",
  column: {
    onHand: "الرصيد المتاح",
    reorder: "نقطة إعادة الطلب",
  },
  lowStock: "مخزون منخفض",
  inStock: "متوفر",
  addLocation: "إضافة موقع",
  stockLevels: "مستويات المخزون",
  emptyTitle: "لا توجد مواد",
  emptyDescription: "أضف المواد في الفهرس لبدء تتبع المخزون.",
  selectMaterial: "اختر مادة لعرض المواقع والحركات وإجراءات الصرف.",
  location: "الموقع",
  direction: "الاتجاه",
  stockIn: "إدخال إلى المخزون",
  stockOut: "إخراج من المخزون",
  reasonHint: "مطلوب (3 أحرف على الأقل).",
  recordAdjustment: "تسجيل التسوية",
  adjustmentRecorded: "تم تسجيل التسوية",
  job: "أمر العمل",
  issuing: "جارٍ الصرف…",
  issueToJob: "صرف إلى أمر العمل",
  materialIssued: "تم صرف المادة",
  addLocationTitle: "إضافة موقع مخزون",
  saveLocation: "حفظ الموقع",
  locationAdded: "تمت إضافة الموقع",
  locationKind: {
    store: "مخزن",
    floor: "أرضية الورشة",
    quarantine: "عزل",
    other: "أخرى",
  },
  totalOnHand: "إجمالي الرصيد المتاح",
  adjust: "تسوية",
  issue: "صرف",
  movementHistory: "سجل الحركات",
  noMovements: "لا توجد حركات بعد.",
  reverseTitle: "عكس هذه الحركة؟",
  reverseDescription:
    "تُسجَّل حركة عكسية مقابل الحركة الأصلية للحفاظ على سجل تدقيق كامل.",
  reverseMovement: "عكس الحركة",
  movementReversed: "تم عكس الحركة",
  reverse: "عكس",
  reversed: "تم العكس",
  kind: {
    opening: "رصيد افتتاحي",
    receipt: "استلام",
    issue: "صرف لأمر عمل",
    return: "إرجاع من أمر عمل",
    adjustment_in: "تسوية وارد",
    adjustment_out: "تسوية صادر",
  },
};
